import { globalStore } from '~/stores';
import { AppContexts } from '~/utils/commonUtils.ts';
import { useEnvAppDataContext } from '~/pages/ExternalPages/EnvAppPages/contexts/EnvAppDataContext.tsx';

enum WorkspacePermissions {
  // will add workspace permissions later
  // once we dog food the workspace permissions
  // we will populate this
}

enum EnvAppPermissions {
  ORG_READ = 'sk_org_read',
  ORG_WRITE = 'sk_org_write',
  ORG_USERS_LIST = 'sk_org_users_list',
  ORG_USERS_INVITE = 'sk_org_users_invite',
  ORG_USERS_DELETE = 'sk_org_users_delete',
  ORG_USERS_ROLE_CHANGE = 'sk_org_users_role_change',
  ORG_SSO_READ = 'sk_org_sso_read',
  ORG_SSO_WRITE = 'sk_org_sso_write',
  ORG_SETTINGS_READ = 'sk_org_settings_read',
  ORG_SETTINGS_WRITE = 'sk_org_settings_write',
  ORG_SCIM_READ = 'sk_org_scim_read',
  ORG_SCIM_WRITE = 'sk_org_scim_write'
}

export type AppPermissions = WorkspacePermissions | EnvAppPermissions;

const getCurrentUserPermissions = (): AppPermissions[] => {
  if (globalStore.appContext === AppContexts.ENV_APP_PAGES) {
    const envAppData = useEnvAppDataContext();
    const currentMembership =
      envAppData.user?.memberships.find(
        ({ organizationId }) => organizationId === envAppData.organizationId
      ) ?? undefined;
    return currentMembership?.permissions ?? [];
  }
  return [];
};

const isAuthorized = (permissions: AppPermissions[]) => {
  const currentUserPermissions: AppPermissions[] = getCurrentUserPermissions();
  return permissions.every((permission) =>
    currentUserPermissions.includes(permission)
  );
};

export { WorkspacePermissions, EnvAppPermissions, isAuthorized };
